import _ from 'lodash';
import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import BubbleContent from '../content/bubble_content';
import ConversationItem from 'models/conversation_item';
import ItemContent from '../item_content';
import ItemMetadata from '../item_metadata';
import Link from 'components/common/link';

export default function NarvarItem({ className, item }) {
  return (
    <ItemContent item={item}>
      <ItemMetadata item={item} text="sent" />
      <BubbleContent className={classnames('narvarItem-content', className)} item={item}>
        <div className="narvarItem-content-info">
          <div className="narvarItem-content-info-section">
            {_.get(item, 'content.leftLabel')}
            <b>{_.get(item, 'content.leftContent')}</b>
          </div>
          <div className="narvarItem-content-info-section">
            {_.get(item, 'content.rightLabel')}
            <b>{_.get(item, 'content.rightContent')}</b>
          </div>
        </div>
        <div className="narvarItem-content-tracking">
          <Link href={_.get(item, 'content.url')}>{_.get(item, 'content.urlLabel')}</Link>
        </div>
      </BubbleContent>
    </ItemContent>
  );
}

NarvarItem.propTypes = {
  className: PropTypes.string,
  item: PropTypes.instanceOf(ConversationItem).isRequired,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/demo/narvar_item.jsx